<template>
  <transition name="slide-notification">
    <div
      v-show="isActive"
      class="notification-box"
      :class="className"
      role="alert"
      :style="styles"
      data-cy="notification-box"
    >
      <transition name="fade">
        <span>
          <button
            v-show="!isLoading"
            @click="toggleIsActive"
            type="button"
            class="close"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
          <template v-if="!isWarning && !isLoading">
            <slot name="icon" aria-hidden="true"></slot>
          </template>
          <template v-else>
            <span v-if="isWarning" class="glyphicon glyphicon-info-sign"></span>
          </template>
          <span v-if="!isLoading" class="ml-10">
            <slot name="success-icon"></slot>
            <template v-if="notifIcon !== ''">
              <img class="mb-5 mr-5" width="22" height="22" :src="notifIcon" />
            </template>
            {{ message }}
            <template v-if="linkText !== ''">
              <a class="link-style" @click="handleMilestoneModal">
                <strong>{{ linkText }}</strong>
              </a>
            </template>
          </span>
        </span>
      </transition>
      <transition name="fade">
        <div>
          <div v-show="isLoading" class="lds-dual-ring"></div>
          <span v-show="isLoading" class="ml-50">Updating...</span>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
  import MilestoneModal from '../authoringPlatform/components/shared/MilestoneModal.vue';
  export default {
    name: 'notification',
    components: {
      MilestoneModal,
    },

    props: {
      isActive: {
        type: Boolean,
        default: true,
      },

      isWarning: {
        type: Boolean,
        default: false,
      },

      isInfor: {
        type: Boolean,
        default: false,
      },

      notifIcon: {
        type: String,
        default: '',
      },

      linkText: {
        type: String,
        default: '',
      },

      isLoading: {
        type: Boolean,
        default: false,
      },

      message: {
        type: String,
        required: true,
      },

      styles: {
        type: String,
        default: '',
      },
    },

    computed: {
      className() {
        let className;
        if (this.isInfor) {
          className = 'alert alert-info';
        } else if (this.isWarning) {
          className = 'alert alert-danger';
        } else {
          className = 'alert alert-success';
        }

        return className;
      },
    },

    methods: {
      handleMilestoneModal() {
        this.$emit('openMilestoneModal');
      },
      toggleIsActive() {
        this.$emit('dismiss');
        this.$emit('update:isActive', !this.isActive);
      },
    },
  };
</script>

<style scoped lang="scss">
  .link-style {
    text-decoration: underline;
  }
  .link-style:hover {
    cursor: pointer;
  }
  @-webkit-keyframes lds-dual-ring {
    0% {
      -webkit-transform: rotate(0);
      transform: rotate(0);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes lds-dual-ring {
    0% {
      -webkit-transform: rotate(0);
      transform: rotate(0);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  .lds-dual-ring {
    position: absolute;
    width: 35px;
    height: 35px;
    top: 7px;
    left: 12px;
    border-radius: 50%;
    border: 3px solid #000;
    border-color: #3c763d transparent;
    -webkit-animation: lds-dual-ring 1.3s linear infinite;
    animation: lds-dual-ring 1.3s linear infinite;
  }

  .notification-box {
    &.alert {
      position: fixed;
      top: 10px;
      right: 10px;
      box-shadow: 0 0 2px #ffffff;
      width: auto;
    }
    .close {
      margin-left: 20px;
    }
  }

  .fade-enter-active {
    transition: all 0.8s ease;
  }
  .fade-leave-active {
    transition: all 0.3s ease;
  }
  .fade-enter {
    opacity: 0;
  }
  .fade-leave-to {
    opacity: 0;
  }

  .slide-notification-enter-active {
    transition: all 0.3s ease;
  }
  .slide-notification-leave-active {
    transition: all 0.3s ease;
  }
  .slide-notification-enter {
    transform: translateX(100px);
    opacity: 0;
  }
  .slide-notification-leave-to {
    transform: translateX(100px);
    opacity: 0;
  }

  .alert-success {
    background-color: #cee6d6;
    color: #000000;
  }
</style>
